export default "__VITE_ASSET__BAPMDBvf__"